import React, { useRef } from 'react';
import styled from 'styled-components';
import AntdDropdown from 'antd/es/dropdown';

import type { FC, ReactNode } from 'react';
import type { DropDownProps } from 'antd/es/dropdown';

interface IContainerProps extends React.HTMLAttributes<Omit<HTMLDivElement, 'ref'>> {
  ref: React.Ref<HTMLDivElement | null | undefined>;
}

interface IDropdownProps extends DropDownProps {
  children: ReactNode;
}

const DropdownContainer: FC<IContainerProps> = styled.div`
`;

export const Dropdown = ({ className, ...props }: IDropdownProps) => {
  const divRef = useRef<HTMLDivElement>();
  const getTooltipContainer = () => divRef.current as HTMLDivElement;

  return (
    <DropdownContainer className={className} ref={divRef}>
      <AntdDropdown {...props} getPopupContainer={getTooltipContainer} />
    </DropdownContainer>
  )
}
